import React from 'react';
import Reactable from 'reactable';
import Item from './ListItem';
import Footer from './Footer';
import {
  mapTableHeaderColumns,
  extractUnassignedSales,
  sumReports,
} from '../helpers';
import * as shapes from '../shapes';
import Tooltip from '../../../../common/tooltip';
import { t } from '../../../../../modules/infra/i18n';

const Table = Reactable.Table;
const Thead = Reactable.Thead;
const Th = Reactable.Th;

const List = ({ items }) => {
  const columns = mapTableHeaderColumns(items);
  const { sales: data, unassigned } = extractUnassignedSales(items);
  const total = sumReports([...data, unassigned]);

  return (
    <Table
      className="c-table-new c-table--small c-table--border c-no-hover"
      columns={columns}
      sortable
      defaultSort={{ column: 'Name', direction: 'asc' }}
      display-if={items.length}
    >
      <Thead>
        {columns.map(column => (
          <Th
            className="u-type--capitalize"
            column={column.key}
            key={column.key}
          >
            {column.label}
            <Tooltip text={t('reports:payouts.tooltip.taxes_collected')} display-if={column.key === 'Taxes Collected'} />
          </Th>
        ))}
      </Thead>
      {data.map(item => Item({ item }))}
      {Footer({ columns: columns.map(col => col.key), unassigned, total })}
    </Table>
  );
};
List.propTypes = {
  items: shapes.commissionSplitReport,
};
List.defaultProps = {
  items: [],
  total: {},
};

export default List;
